/**
 * One abort token for in-flight box-select resolution. Left-click and box select
 * live in separate hooks, so a local generation ref in the box handler cannot see
 * a later canvas click. Same idea as {@link abortSharedSelection}.
 *
 * Same-mouseup clicks after a box must NOT call {@link invalidateSelectBoxAbort}:
 * they are suppressed by the 200ms completion guard. Real clicks after that window
 * must invalidate so the landing box cannot overwrite the new selection.
 */

let generation = 0;
let controller = new AbortController();

/** Start a box-select resolve. Aborts any previous attempt. */
export function beginSelectBoxAbort(): { generation: number; signal: AbortSignal } {
    controller.abort();
    controller = new AbortController();
    generation += 1;
    return { generation, signal: controller.signal };
}

export function getSelectBoxAbortGeneration(): number {
    return generation;
}

/** A later canvas selection took ownership — drop the landing box. */
export function invalidateSelectBoxAbort(): void {
    generation += 1;
    controller.abort();
    controller = new AbortController();
}

/** Test-only. */
export function resetSelectBoxAbort(): void {
    generation = 0;
    controller = new AbortController();
}
